import { render, staticRenderFns } from "./ConversationAiResponse.vue?vue&type=template&id=b9062c5a&scoped=true"
import script from "./ConversationAiResponse.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationAiResponse.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9062c5a",
  null
  
)

export default component.exports